import { render, staticRenderFns } from "./RatingView.vue?vue&type=template&id=74d356a6&scoped=true&"
import script from "./RatingView.vue?vue&type=script&lang=js&"
export * from "./RatingView.vue?vue&type=script&lang=js&"
import style0 from "./RatingView.vue?vue&type=style&index=0&id=74d356a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d356a6",
  null
  
)

export default component.exports